GW.define('DesignedByBronet', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'made-by-bronet',
			children: [{
				nodeName: 'a',
				href: 'https://bronet.cz/',
				target: '_blank',
				children: [{
					textContent: _('Designed & developed by')
				}],
			}, {
				nodeName: 'a',
				href: 'https://bronet.cz/',
				target: '_blank',
				children: [{
					nodeName: 'img',
					alt: 'bronet logo',
					src: '/imgs/bronet.svg',
				}],
			}]
		}, this);
	},
});

GW.define('CompanyContacts', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			nodeName: 'p',
			children: [
				'Alkohol Taxi s.r.o.\n',
				'Korunní 2569/108\n',
				'101 00 Praha 10 - Vinohrady\n',
				'IČ: 093 60 581\n',
				'E-mail: ', {
					nodeName: 'a',
					textContent: 'info@alkoholtaxi.cz',
					href: 'mailto:info@alkoholtaxi.cz'
				},
			]
		}, this);
	},
});

GW.define('AppLogo', 'GW.Component', {
	variant: 'black',
	app_title: 'alkoholtaxi.cz',
	href: '/',

	initComponent() {
		this.el = document.gwCreateElement({
			nodeName: 'a',
			href: this.href,
			className: 'app-logo ' + this.variant,
			children: [{
				nodeName: 'img',
				src: this.getLogoPath(),
			}, {
				className: 'title',
				textContent: this.app_title,
			}],
		}, this);
	},

	getLogoPath() {
		if (this.variant == 'white') {
			return '/icons/logo-white.svg';
		}

		return '/icons/logo-red.svg';
	},
});
